/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateWhatsAppStorePathParams,
	CandidateWhatsAppStoreRequest,
	CandidateWhatsAppStoreResponse,
} from '../types/CandidateWhatsAppStore'

/**
 * POST /candidates/:candidateId/whatsapp
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::store
 */
export async function candidateWhatsAppStore(
	candidateId: CandidateWhatsAppStorePathParams['candidateId'],
	data: CandidateWhatsAppStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateWhatsAppStoreResponse>> {
	return axiosInstance.post(`/candidates/${candidateId}/whatsapp`, data, config)
}
